export var CacheKey;
(function (CacheKey) {
    CacheKey["Auth"] = "authResult";
    CacheKey["AuthTenantServer"] = "authTenantServerResult";
    CacheKey["AuthInstance"] = "authInstance";
    CacheKey["DynamicConfig"] = "dynamicConfig";
    CacheKey["EventList"] = "eventList";
    /** Device data from BE */
    CacheKey["DeviceData"] = "deviceData";
    /** Device info - HW */
    CacheKey["DeviceInfo"] = "deviceInfo";
    /** Detected locale from GeoIP */
    CacheKey["Locale"] = "deviceLocale";
    /** Locally tracked migration execution results */
    CacheKey["ExecutedMigrations"] = "executedMigrations";
    /** Debug data from emergency event list generation */
    CacheKey["EmergencyELDebug"] = "emergencyELDebug";
    /** Timestamp of last crash-triggered system reboot (rate-limiting) */
    CacheKey["LastCrashReboot"] = "lastCrashReboot";
    /** Count of consecutive offline-triggered reboots (capped) */
    CacheKey["OfflineRebootCount"] = "offlineRebootCount";
})(CacheKey || (CacheKey = {}));
//# sourceMappingURL=CacheKey.js.map